
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexO55QyER2XGCfOw6qMvh8HBNtieSPrX4sCRuGTJC4MLMMeta } from "/builds/marketing/website-2.0/pages/index.vue?macro=true";
import { default as eofyRo671gX5SPCmVZtSv1ZhEJSltl8JVJpChGcdq9dPWccMeta } from "/builds/marketing/website-2.0/pages/lp/eofy.vue?macro=true";
import { default as indexj8M1w5HAetm90OFyu2ouKIrv1D2y_45dnBCYyk1W_hh34Meta } from "/builds/marketing/website-2.0/pages/lp/index.vue?macro=true";
import { default as indexHQlUxOr3FIBaXGA_N1mWnQ_45Yu89J6z1Yd1ngb45k0GgMeta } from "/builds/marketing/website-2.0/pages/blog/index.vue?macro=true";
import { default as indexHfwpjDa6DavHIoyTSO832jek93mh0yBH1KMIJyZ5okgMeta } from "/builds/marketing/website-2.0/pages/ssbi/index.vue?macro=true";
import { default as appt31ZhePyOLUT9BsiiVPZmZwmbNaPTGaFW9X76_G8nz7kMeta } from "/builds/marketing/website-2.0/pages/tools/appt.vue?macro=true";
import { default as indexOGt_45vYGoUa3aRcFMbTJozTokaGm0JSKrX_pTqGETtMoMeta } from "/builds/marketing/website-2.0/pages/legal/index.vue?macro=true";
import { default as mapMk_jL8XR414QhSaxmpLWdOXAJP417M2mK_uGDSoR_45gQMeta } from "/builds/marketing/website-2.0/pages/network/map.vue?macro=true";
import { default as indexhsz4bqNeUWRKUoMLYkOybC7goDw8_FkTeYIQCxHfGV8Meta } from "/builds/marketing/website-2.0/pages/speed/index.vue?macro=true";
import { default as indexaHWzfWHS3gmXl2b0hdchilv8Bvd_45SJspCEQZEYhgHk8Meta } from "/builds/marketing/website-2.0/pages/search/index.vue?macro=true";
import { default as indexo9aLNfeI9UOTlx8AtSjR_AaVMpffxzDdyjs5v4YpO4wMeta } from "/builds/marketing/website-2.0/pages/bundles/index.vue?macro=true";
import { default as indext3nQo7P7RCNsMlV9XL36wPs6qJ49ovnsX3ha1927EnEMeta } from "/builds/marketing/website-2.0/pages/careers/index.vue?macro=true";
import { default as index5PruIdF8t0pU1bcmwuqAIPe4QDd_Pj8wliXhj6ZWubwMeta } from "/builds/marketing/website-2.0/pages/contact/index.vue?macro=true";
import { default as _91slug_937Xclb4ez15rUrYPdz_GN8Y_kG9yE8998t2_45S5rfhHMAMeta } from "/builds/marketing/website-2.0/pages/mobile/[slug].vue?macro=true";
import { default as indexX4Ab16he2rstrKnn_45j_p_uAV6DyJ_45W2LZlqJ_4513pZd0Meta } from "/builds/marketing/website-2.0/pages/network/index.vue?macro=true";
import { default as indexp3SZTyhvg2CF5hVHKJ6EqoSn19GIiQH0hDskQ6fp6o4Meta } from "/builds/marketing/website-2.0/pages/reviews/index.vue?macro=true";
import { default as index54Wqmf8f7TfXhRO0Ar2nq8REsXSTXRfwDWur2dYIqO8Meta } from "/builds/marketing/website-2.0/pages/about-us/index.vue?macro=true";
import { default as _91_46_46_46slug_9359KoB_45ZvR_456n1uumciplqCCxupIihTR9VKYCf7wVvT8Meta } from "/builds/marketing/website-2.0/pages/blog/[...slug].vue?macro=true";
import { default as indexq9niHaAUACitSvOmFMKYyYYwESQys3zsKUQrc_xhVeUMeta } from "/builds/marketing/website-2.0/pages/business/index.vue?macro=true";
import { default as index8SphEQZZvVH_S8JNnTT_45RS3L8wE1nxkSwFMUiM_EmiQMeta } from "/builds/marketing/website-2.0/pages/customer/index.vue?macro=true";
import { default as faultQMMCGIAdJrBELFJIIDqQLE3tuhUgCxSzikuPXnuaNnEMeta } from "/builds/marketing/website-2.0/pages/feedback/fault.vue?macro=true";
import { default as indexjvfCzPsfYe6PGaFsnnFmmR83Kamc4A1R_HXg8a7Ud3sMeta } from "/builds/marketing/website-2.0/pages/feedback/index.vue?macro=true";
import { default as salesYQssZkGDQ4dgNs_45ttuiolRyh7Qh4gZ6dLdQ6EgS31oAMeta } from "/builds/marketing/website-2.0/pages/feedback/sales.vue?macro=true";
import { default as indexyCDoof8q7lhJQEKaNjVl6876QMQeTDi_fS6Evfn_yy0Meta } from "/builds/marketing/website-2.0/pages/insights/index.vue?macro=true";
import { default as indexM7gOPVNTYn_BPzczD0IIRvGebZKeIAju1JSrtTRYZH0Meta } from "/builds/marketing/website-2.0/pages/blog/tags/index.vue?macro=true";
import { default as black_45friday6rKYK2wdaTybGx_45DmnMvBhzhg9_45GTJGkesozxnXJ8skMeta } from "/builds/marketing/website-2.0/pages/lp/black-friday.vue?macro=true";
import { default as outagesJgaozrwS3_eCZbr7PlaK6ItbYQ0Y3D__45EXIR_45EYuc8MMeta } from "/builds/marketing/website-2.0/pages/network/outages.vue?macro=true";
import { default as indexCMnTU1mEhazxOGEfPhETq0jtRdGIuTZPAbCql0mW880Meta } from "/builds/marketing/website-2.0/pages/wholesale/index.vue?macro=true";
import { default as contact1VWwGdEnf_4_hKQTeY4AY0Mq_CEJW7RatVQWlfShi1sMeta } from "/builds/marketing/website-2.0/pages/business/contact.vue?macro=true";
import { default as indexzFPVwF2c4lLXa0Bs5hv9XRO1Kk0y1N3JJz2JR4hj24IMeta } from "/builds/marketing/website-2.0/pages/enterprise/index.vue?macro=true";
import { default as telstra4tZA6afarKwWFFv45CMDBkGlt5rbl7b2rFCb9DOCzRYMeta } from "/builds/marketing/website-2.0/pages/internet/telstra.vue?macro=true";
import { default as indexUcFWccHpo44oc6eo_ZGAvL0JJTH4y6up38fZJCy3YbwMeta } from "/builds/marketing/website-2.0/pages/speed-test/index.vue?macro=true";
import { default as carbon3DzI8XXcfi3B9OkFeqBt9_45FS4kgbLr7X4qeueZYHXfMMeta } from "/builds/marketing/website-2.0/pages/wholesale/carbon.vue?macro=true";
import { default as all_45articless0HOXE_n1Axv9bx54PBzdnKj5tzt16DeCiqDT0pB__kMeta } from "/builds/marketing/website-2.0/pages/blog/all-articles.vue?macro=true";
import { default as indexORW0FRlBAm7UApZ_45oJXTL8qfQzh_bfJCZwLyKa6Ck_QMeta } from "/builds/marketing/website-2.0/pages/business/lp/index.vue?macro=true";
import { default as novabyXFBrTFpa7ZgquAVCzqf5KX4YY_ZbrwLaoCIRi845MMeta } from "/builds/marketing/website-2.0/pages/case-studies/nova.vue?macro=true";
import { default as complaintHamcbqEdI5THsStxloDelOYW8D1rmXtXOUplAcNWzicMeta } from "/builds/marketing/website-2.0/pages/contact/complaint.vue?macro=true";
import { default as indexvBBDnjyBro8k2htoUxyaTGPr0gISwZk2PFkUFaqvvhAMeta } from "/builds/marketing/website-2.0/pages/help-centre/index.vue?macro=true";
import { default as hardwareUzbAr8CKvRsfx61_453RvsO2C49FdFSo1J2S26EJfwknAMeta } from "/builds/marketing/website-2.0/pages/internet/hardware.vue?macro=true";
import { default as indexE4fJdnl2L_45PaLUlQEb2jMRdezrDK0ytGcdtrNlbFJ5cMeta } from "/builds/marketing/website-2.0/pages/moving-home/index.vue?macro=true";
import { default as indexMSf__45uz0Qq3zpAQv92v7E9Ii7MUVvOcjd9DXdw3tJcsMeta } from "/builds/marketing/website-2.0/pages/blog/authors/index.vue?macro=true";
import { default as akubra3Xqu_n7N2iQTnyoaAQatJTy7EugT5HJsqc6wT0vaF8kMeta } from "/builds/marketing/website-2.0/pages/business/lp/akubra.vue?macro=true";
import { default as indexBwf0zD7PDnaVwQJznWAlYwdccO0PomCtD3iJFQAipHsMeta } from "/builds/marketing/website-2.0/pages/case-studies/index.vue?macro=true";
import { default as nbn_45plansx39h_45XyhiRJpJeO1p_45V30xgWDbLASPwY0BJjAessvBsMeta } from "/builds/marketing/website-2.0/pages/internet/nbn-plans.vue?macro=true";
import { default as indexzDkmryCWaNFU2i8VaOzuTj0_454gc013isPcR8EVk24LIMeta } from "/builds/marketing/website-2.0/pages/media-centre/index.vue?macro=true";
import { default as indexslnOz_45JjJCBFg3KofaXHl0XsxsjtbFdWE43QqQ_45kwJIMeta } from "/builds/marketing/website-2.0/pages/myaussie-app/index.vue?macro=true";
import { default as cvc_45graphs3YKyjIpx9UN173FYe8cqfQ1epLkQU04oP4pJ_45QIeU3oMeta } from "/builds/marketing/website-2.0/pages/network/cvc-graphs.vue?macro=true";
import { default as ping_45times9qcO59fYGE4dAn9W5qnSXk7DU1meabXg4eHrp29v3r0Meta } from "/builds/marketing/website-2.0/pages/network/ping-times.vue?macro=true";
import { default as indexR6_5s_450zp10oWaD0zNF7FtxWrv4y3kUN0x1vVXF56nQMeta } from "/builds/marketing/website-2.0/pages/our-products/index.vue?macro=true";
import { default as activate_45simQVMn2PcB6fK0Mlzfnl7Swaotjop7L4uq1oZHxICMulsMeta } from "/builds/marketing/website-2.0/pages/tools/activate-sim.vue?macro=true";
import { default as release_45formTf26KGFB0srA6C3YFMmpIDQqt_45IlVxt2k8a4Ppm1MS4Meta } from "/builds/marketing/website-2.0/pages/tools/release-form.vue?macro=true";
import { default as indexNb_45fn9Qcy7tvT2b_45UQiSWbMywcJ9bKGjiWCITBxmFlkMeta } from "/builds/marketing/website-2.0/pages/wholesale/lp/index.vue?macro=true";
import { default as indexgGcPnMzpGK9w3O84tiPxeKsSPIgXZdI4bWTOJYkR11EMeta } from "/builds/marketing/website-2.0/pages/accessibility/index.vue?macro=true";
import { default as _91_46_46_46slug_93x1GM7Hduof6P3p3CgC77YqMHacdOw0EZYtpbMZCokzkMeta } from "/builds/marketing/website-2.0/pages/blog/tags/[...slug].vue?macro=true";
import { default as akubrayP12XyaEfLqeI6QwR21au_45K5wXOTX63IJfnWnf_45oR90Meta } from "/builds/marketing/website-2.0/pages/case-studies/akubra.vue?macro=true";
import { default as indexlJO8onq8B0B8kvS4rV_3bSfy5cvXXdoTRUYm6Zpd7SIMeta } from "/builds/marketing/website-2.0/pages/enterprise/lp/index.vue?macro=true";
import { default as indexMlVeeW9of2mj2t10tp_dngKj7yWUDK9bGfMqtfk_45LOUMeta } from "/builds/marketing/website-2.0/pages/insights/tags/index.vue?macro=true";
import { default as gamers_45nbn1kK8lZQLbSUiv1pk_IRXb5gtMzrtHrNmcYHbqerRNBAMeta } from "/builds/marketing/website-2.0/pages/internet/gamers-nbn.vue?macro=true";
import { default as home_45phonefmaHExvk66_GtadDRbDlgR9gNGlo0OsPUr3kRzBC_45XMMeta } from "/builds/marketing/website-2.0/pages/internet/home-phone.vue?macro=true";
import { default as indexAr7V41WSF9gWeMRZSEIP1BohbOCSIG1p9d12PAlFd4cMeta } from "/builds/marketing/website-2.0/pages/wholesale/msp/index.vue?macro=true";
import { default as cumulusKbfmHymEVfuD_45apBu5raL5DyCAIIIRli_35n5EZCPH4Meta } from "/builds/marketing/website-2.0/pages/case-studies/cumulus.vue?macro=true";
import { default as westpacMFfagoDZ3CIVvdrsSWFefRtwsi8f9NC3ww3Z9MFcWu0Meta } from "/builds/marketing/website-2.0/pages/case-studies/westpac.vue?macro=true";
import { default as vmwareoLPMvgFIoHFFJ2gYEN5EZ9eHLIHiBPWLJ11qeT428z0Meta } from "/builds/marketing/website-2.0/pages/enterprise/lp/vmware.vue?macro=true";
import { default as seniors_45nbnUZf3nvGyReBFdLmdce_45P1j3Z4MGLMpaepvNv_rXXhqQMeta } from "/builds/marketing/website-2.0/pages/internet/seniors-nbn.vue?macro=true";
import { default as privacy_45policy_VuDbMD47xu1sRw6Gr5y9EptiG55JWuvG3ErRjCJ0ycMeta } from "/builds/marketing/website-2.0/pages/legal/privacy-policy.vue?macro=true";
import { default as data_45only_45simUZL_45auS14PbNKkpKUGGgdFPY3iD2bv9nPhnb5TeJfXQMeta } from "/builds/marketing/website-2.0/pages/mobile/data-only-sim.vue?macro=true";
import { default as indexJdvZjCwrOpEwSMQJ4ovEDd_45hDcisuL41EqrogFr_45d_AMeta } from "/builds/marketing/website-2.0/pages/onboarding-hub/index.vue?macro=true";
import { default as index31GMCYS3RO2vFSlKr05bHFXp28GysL53P3rj9hGG_45JwMeta } from "/builds/marketing/website-2.0/pages/refer-a-friend/index.vue?macro=true";
import { default as indexSDwBRR4W7OAAtdgPjnTr9_459GRR_DWu1Z4rcvytLd9DUMeta } from "/builds/marketing/website-2.0/pages/about-us/awards/index.vue?macro=true";
import { default as testimonialskfKfDaEYMhTuPzdcCjf_RttEqt_DLRE8gshXrOLxBI0Meta } from "/builds/marketing/website-2.0/pages/business/testimonials.vue?macro=true";
import { default as zintelReJxU9yQUMHKBRYiIuCuWbsFo_Kkzmw8_lEbGThV5b4Meta } from "/builds/marketing/website-2.0/pages/business/voice/zintel.vue?macro=true";
import { default as indexP5nkLEiTe_M7p49aVJEfJOUdOiKDzpiQOnWB2NCOOP8Meta } from "/builds/marketing/website-2.0/pages/investor-centre/index.vue?macro=true";
import { default as sim_45only_45plansATYjZOLfULiixEH4OE1g1DphH22v8u8GkFuuegs1AJsMeta } from "/builds/marketing/website-2.0/pages/mobile/sim-only-plans.vue?macro=true";
import { default as white_45labelaJSo01liDYNNPeybfEwMNHMHgqg0pyfts5dIHjKc8psMeta } from "/builds/marketing/website-2.0/pages/wholesale/white-label.vue?macro=true";
import { default as _91_46_46_46slug_93tlGVwAlP5r1nR484jkG44VBeWrsvh7hYSBKBENZCGpsMeta } from "/builds/marketing/website-2.0/pages/blog/authors/[...slug].vue?macro=true";
import { default as ace_45radioC5h3OiqagFHiyM5ND9kDUUuF5P8wrANH_45hDr6S0KBYoMeta } from "/builds/marketing/website-2.0/pages/case-studies/ace-radio.vue?macro=true";
import { default as foodworksHsnAHWedekOL4fg18R7eu98v6LyWZ3ZDfCen65MQk0QMeta } from "/builds/marketing/website-2.0/pages/case-studies/foodworks.vue?macro=true";
import { default as green_45cupFcR7tSl3fRpAmYoPr_45HSMf5iHk4j5LG2T743NgsulroMeta } from "/builds/marketing/website-2.0/pages/case-studies/green-cup.vue?macro=true";
import { default as index8zjlWip_KfGbU0I97UeYWjQ0mZcuB0dC0_4EEeCyUjAMeta } from "/builds/marketing/website-2.0/pages/help-centre/tags/index.vue?macro=true";
import { default as indexUa5xWQnwuFZIFJGIixpqBEELe0lMI_45j_Yg8t2LMiRFoMeta } from "/builds/marketing/website-2.0/pages/insights/leaders/index.vue?macro=true";
import { default as entertainmentpvKiqxLv0dOvbzuDhIqamKEpUbtWeqVksqkyuPijk2wMeta } from "/builds/marketing/website-2.0/pages/internet/entertainment.vue?macro=true";
import { default as ultrafast_45nbngIox6_fgO6yN0XV_euenFGDk53QQBX4IGFJ8hE5RVPcMeta } from "/builds/marketing/website-2.0/pages/internet/ultrafast-nbn.vue?macro=true";
import { default as _91_46_46_46slug_93VdoShCA91751cPIMyMsemjhl_SCrj8NeJSJPxhgfuxMMeta } from "/builds/marketing/website-2.0/pages/media-centre/[...slug].vue?macro=true";
import { default as fibre_45operationsr_e9n_IZY3Q7FuExOxk_eDAUlBvSWl_45tYE9nE_45scmfsMeta } from "/builds/marketing/website-2.0/pages/tools/fibre-operations.vue?macro=true";
import { default as indexixQj4iGZOCEcxY_45xTtlhESGU6IVAbAmABVEdCONsqo4Meta } from "/builds/marketing/website-2.0/pages/business/feedback/index.vue?macro=true";
import { default as indexN234YSi2ZdjVWmPjadSwIVwQRSq3C1rEFgfQqgkggkUMeta } from "/builds/marketing/website-2.0/pages/enterprise/carbon/index.vue?macro=true";
import { default as index9rXMsUTOZ1dfnaNS8y14UqzmLP6RD1x9gXZwJ8hKT60Meta } from "/builds/marketing/website-2.0/pages/help-centre/phone/index.vue?macro=true";
import { default as _91slug_93Sel_455FxhhAm0EmzL7n5FxsivVhi4z2dJIWGVYcdmhcUMeta } from "/builds/marketing/website-2.0/pages/insights/leaders/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93j0BwdORrEMaBQiQCSisdVD6XoWV1SQD2YCL0QflCWHMMeta } from "/builds/marketing/website-2.0/pages/insights/tags/[...slug].vue?macro=true";
import { default as fixed_45wirelesswQZWA1DjWhwvN0bKwos_6ePTsIDKnZJUmhgzMq3LnfYMeta } from "/builds/marketing/website-2.0/pages/internet/fixed-wireless.vue?macro=true";
import { default as opticomm_45plansqz7eO8114ZuF6HgOC6PpsAy_XY9ydBNQ8LP8DjwB4tYMeta } from "/builds/marketing/website-2.0/pages/internet/opticomm-plans.vue?macro=true";
import { default as big_45tech_45competitioneKM4tygE8Qxbt2uR2LkIqx65yxkmCM39GSMMogzCohsMeta } from "/builds/marketing/website-2.0/pages/lp/big-tech-competition.vue?macro=true";
import { default as indexABh8krsUjA1L8L3iqm37c6PnPQech_45a6QKSy9EFbXjcMeta } from "/builds/marketing/website-2.0/pages/wholesale/carrier/index.vue?macro=true";
import { default as datavaT6pH1CvqEmDkJ2hfuIZL65tWzRuRdtlDr6W1i6bxcMeta } from "/builds/marketing/website-2.0/pages/wholesale/services/data.vue?macro=true";
import { default as index9nT4xzZZThplu_45Ap2h_770Mmrk3LmiUXRylFNS7j0hQMeta } from "/builds/marketing/website-2.0/pages/about-us/community/index.vue?macro=true";
import { default as faktortelIsf__M_452jrFTOX49Omcbm8ge9_45Xpm1rJgPwzCxF39p0Meta } from "/builds/marketing/website-2.0/pages/business/voice/faktortel.vue?macro=true";
import { default as harris_45woodzUWieJRcT6nKS1E6jh199nmGvPuwJLVj2QSVHe79SHEMeta } from "/builds/marketing/website-2.0/pages/case-studies/harris-wood.vue?macro=true";
import { default as indexOpYu0Y6kXtjFbQR6vu3FAS5SKx1AKXiaS4KVSUxYDScMeta } from "/builds/marketing/website-2.0/pages/enterprise/contact/index.vue?macro=true";
import { default as indexLJjcEjF_CgDmR6BeEboa1oeu8xk8vT5XFhcz_45MZBbcwMeta } from "/builds/marketing/website-2.0/pages/help-centre/mobile/index.vue?macro=true";
import { default as _3g_45network_45changeR5xvVTz9f5o48M0Mzrs4IcJPBafwrGadar8TuzV8hbkMeta } from "/builds/marketing/website-2.0/pages/mobile/3g-network-change.vue?macro=true";
import { default as voice5X_OaTlu1XM6hsbQuN5N2MccLpEkMeR14EhTgK9ko4MMeta } from "/builds/marketing/website-2.0/pages/wholesale/services/voice.vue?macro=true";
import { default as indexdzv7ouRTi3rRksXkvOspeBqxFXG1MEjsZ1Qz2LxOj2sMeta } from "/builds/marketing/website-2.0/pages/about-us/leadership/index.vue?macro=true";
import { default as _4g_45backup2Rrx5ZJAU3Vff_0qOAANy3DmOhs9G3KuxYVKu31FlZIMeta } from "/builds/marketing/website-2.0/pages/business/mobile/4g-backup.vue?macro=true";
import { default as sim_45plansrO3aAk6K0BQ2u2Q8f83ezprjyX_n4BG2pUs0E1kKzoAMeta } from "/builds/marketing/website-2.0/pages/business/mobile/sim-plans.vue?macro=true";
import { default as hosted_45pbxkyYqPTsls_T4ZYFx3EGdvuviA_45e_45m_0gX4xnqA3IPVgMeta } from "/builds/marketing/website-2.0/pages/business/voice/hosted-pbx.vue?macro=true";
import { default as sip_45trunks4uMdE49lbCVI6Y3K9IhGqY2wktI6NZND3RQysexOJiUMeta } from "/builds/marketing/website-2.0/pages/business/voice/sip-trunks.vue?macro=true";
import { default as voip_45phoneb_IUkfbpJ6_45q_wjQR34Oyzv1ujM7NwuhFxrvL3lkcVUMeta } from "/builds/marketing/website-2.0/pages/business/voice/voip-phone.vue?macro=true";
import { default as indexqdUMy6Fy9KIZkB3bBigC35hPzW2N_U8B5mwcYm2kNi8Meta } from "/builds/marketing/website-2.0/pages/high-speed-upgrades/index.vue?macro=true";
import { default as nbn_45fttp_45upgradef_gTfRbtWP7p40Q4y3N4Ij7842hNo6X_Dp38qDFt2ygMeta } from "/builds/marketing/website-2.0/pages/internet/nbn-fttp-upgrade.vue?macro=true";
import { default as all_45articlesmrH_45kjAPLE0hZhPwJpIV8dHFlbz6vm825K1oQJWyZdQMeta } from "/builds/marketing/website-2.0/pages/media-centre/all-articles.vue?macro=true";
import { default as partner_45programNewSZ1A6rrR_45Nzo0GsI3C658keRPgdKk0yheDqkUwyEMeta } from "/builds/marketing/website-2.0/pages/wholesale/partner-program.vue?macro=true";
import { default as indexWZh2J8XMebz2jRMNmYwHie_qsAoaF6ywRczVT2HnYlMMeta } from "/builds/marketing/website-2.0/pages/about-us/our-history/index.vue?macro=true";
import { default as fortinetx7D8e3H6K8wLZV2784_007qYgADTujm_Hrf9qDJum_45gMeta } from "/builds/marketing/website-2.0/pages/business/internet/fortinet.vue?macro=true";
import { default as akd_45softwoodsDAV_45X6PcrFs7DTKnmKTeq5Jd2uGWt39_45St469_f_454rwMeta } from "/builds/marketing/website-2.0/pages/case-studies/akd-softwoods.vue?macro=true";
import { default as indexEGmsT5JvpNQDMSkfsyG9sTBcPmBtjKAQb8Lb7s8NQMYMeta } from "/builds/marketing/website-2.0/pages/help-centre/internet/index.vue?macro=true";
import { default as _91_46_46_46slug_93JLQE3Bm4Vv_45fXKR_MV1wtD56BRgW_45ucaT6adS9Ca49UMeta } from "/builds/marketing/website-2.0/pages/help-centre/tags/[...slug].vue?macro=true";
import { default as become_45a_45partnerVewXW6ysrpbXJhlUIojmfWQJS7IuVkuL6OiOBsKQco4Meta } from "/builds/marketing/website-2.0/pages/wholesale/become-a-partner.vue?macro=true";
import { default as nbn_45plansJyfO_45MXw3aaP8_IVxVjWP8zessBJ0HKqD8P27GqN_1MMeta } from "/builds/marketing/website-2.0/pages/business/internet/nbn-plans.vue?macro=true";
import { default as great_45southernjvW5Rkyy2EgHlYhwjqjZ_nvVrk12vhfuW8U7hvG0E10Meta } from "/builds/marketing/website-2.0/pages/case-studies/great-southern.vue?macro=true";
import { default as james_45cook_45uniUaQZXZ1B4vdGGlUreUqZvdUOIaz4AwHba5mHCM4c97gMeta } from "/builds/marketing/website-2.0/pages/case-studies/james-cook-uni.vue?macro=true";
import { default as itKYBA4qc2YfygvfNoflQNlei6lZ_Sq5j1G1L4_8qC_45V4Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/it.vue?macro=true";
import { default as webex_45connect4TAEYXcIJ5v2p9ePYgrfsxgqhRodioZejPn0dKrQmmQMeta } from "/builds/marketing/website-2.0/pages/enterprise/lp/webex-connect.vue?macro=true";
import { default as _91_46_46_46slug_93viZDyfy8nGQ86QAeOGMGoYmbWwWJ8kfrTxd2uW4HL7IMeta } from "/builds/marketing/website-2.0/pages/help-centre/phone/[...slug].vue?macro=true";
import { default as indexES8_458gtL6C5Di3BOHA1HphBRAGuoFvFEh6Hjgog6U4gMeta } from "/builds/marketing/website-2.0/pages/insights/product-news/index.vue?macro=true";
import { default as connection_45insightsGFKbWVF2ArsUaY2NAjYkLlbdL1NQ0QjcLj_45M3mgyN6oMeta } from "/builds/marketing/website-2.0/pages/network/connection-insights.vue?macro=true";
import { default as mobile_45coverage_45mapQY58gFcdxFlkgaOeynMGPJKuCS04A4yGtNRzYBImbnMMeta } from "/builds/marketing/website-2.0/pages/network/mobile-coverage-map.vue?macro=true";
import { default as retailwW_UITTG_45krUlHaatP9bZuTgXGYb1kDyUnvevdpgIhgMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/retail.vue?macro=true";
import { default as mundaring_45shireSOB5nsaTXK9rNvhbpuhoWlMcDZB3i1_45V9j1v0C7_45CYoMeta } from "/builds/marketing/website-2.0/pages/case-studies/mundaring-shire.vue?macro=true";
import { default as _91_46_46_46slug_93PFbL7THDi_45k1eD2bAFRDbIebgqvFDBq6PxjUq4lY9WAMeta } from "/builds/marketing/website-2.0/pages/help-centre/mobile/[...slug].vue?macro=true";
import { default as _91slug_93J7kGPg0xlLnIWWmD03DfupuxW2jPCes2IvGtK723Y_gMeta } from "/builds/marketing/website-2.0/pages/insights/product-news/[slug].vue?macro=true";
import { default as financeAYW0JYcVWhKVvIaPTUOF2gNp8L4hE2GmsLNuuznMA5AMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/finance.vue?macro=true";
import { default as national_45storage2UbobOCo3M6bCvNoIOv1SQf24CZkaQYrdbuMxpqCP8YMeta } from "/builds/marketing/website-2.0/pages/case-studies/national-storage.vue?macro=true";
import { default as vicses_45nillumbikEwA_4556agSgfF91UsgxJmTi8OyDnTe8Fig8bu9caB_45EcMeta } from "/builds/marketing/website-2.0/pages/case-studies/vicses-nillumbik.vue?macro=true";
import { default as cloudkgiAae0ScNb5eil_Cm1K7pTxBiFxfFUscfYED14dPPIMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/cloud.vue?macro=true";
import { default as business_45success_45teamwqZamkUxCc6wLRZ2nJr5RjOptwK0UIIz94fD_45e6O_45O4Meta } from "/builds/marketing/website-2.0/pages/business/business-success-team.vue?macro=true";
import { default as aussie_45fibreHPY48eGDuXrkcH2xdqVydcSKGzO1EY_45Yn3_45MgPCDnGcMeta } from "/builds/marketing/website-2.0/pages/business/internet/aussie-fibre.vue?macro=true";
import { default as aussie_45fibre_45ebookrA_45HyjpTu038WZ0bJIfqCRs94qnDdwjelNVqE9aCiAUMeta } from "/builds/marketing/website-2.0/pages/business/lp/aussie-fibre-ebook.vue?macro=true";
import { default as _91_46_46_46slug_93FY5HGaktyQp5ZDZA23c99nf1hC67kwve36aHMNHbrb8Meta } from "/builds/marketing/website-2.0/pages/help-centre/internet/[...slug].vue?macro=true";
import { default as legendary_45ashes_45competitionRvxa8rIV__45tBkHwLUIag1sSF3kAMbr2wa60hyYYbPE0Meta } from "/builds/marketing/website-2.0/pages/lp/legendary-ashes-competition.vue?macro=true";
import { default as educationbbqS0PilNdpoLlaAKUm3dXdtsO77RxD3ZXQy9RO61_45gMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/education.vue?macro=true";
import { default as townsville_45dioceseUmvNDJD1V_CDgloJ_xqcYNlWVClp_qSFONRGwPhJhfMMeta } from "/builds/marketing/website-2.0/pages/case-studies/townsville-diocese.vue?macro=true";
import { default as retailLfjBUuNJsXNftUzf1DZxDuKGASArPz9PoRbtkGe2TssMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/retail.vue?macro=true";
import { default as aussie_45fibrer9VtUZKzGLYE4xQPx6j2ZfgJPpTH_hNjjsej_pgzcw4Meta } from "/builds/marketing/website-2.0/pages/wholesale/services/aussie-fibre.vue?macro=true";
import { default as healthcare2AnPVqaoebizhqwwLwpvQeDpo8Td4rYJn4Pjje26zjoMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/healthcare.vue?macro=true";
import { default as mobile_45broadbandCUkah52nHFr6JedsvqHOeIuTOlEuHFLldf7NV2edGuYMeta } from "/builds/marketing/website-2.0/pages/business/mobile/mobile-broadband.vue?macro=true";
import { default as finance6i8TYeDx6B7RI9QcCJUHzxrBP8tDEc7ehnMrZ_LDE0wMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/finance.vue?macro=true";
import { default as voice_45carrierxb2R2vVPdi36NO_o05Iv5OjEu1r9NptQk9pg9_AtSWsMeta } from "/builds/marketing/website-2.0/pages/wholesale/services/voice-carrier.vue?macro=true";
import { default as SustainabilityvfP6Xrv8rIfo0me3JQ0r3gPS00KxjyANwKjZNAE4kFwMeta } from "/builds/marketing/website-2.0/pages/about-us/community/Sustainability.vue?macro=true";
import { default as network_45devicesFH2oVANz_Q7_45L_458gjF76SJ1edzAss0SFvKVaHgSigtAMeta } from "/builds/marketing/website-2.0/pages/business/internet/network-devices.vue?macro=true";
import { default as cfa_45hoppers_45crossingeEeeYhrarg5O64ltw73774SNLCnsVNso_NmRnhFa3VUMeta } from "/builds/marketing/website-2.0/pages/case-studies/cfa-hoppers-crossing.vue?macro=true";
import { default as investigator_45college5sGLHGAEmeSQflxNwCPoGFncjhExypadE5f9G6XoAIAMeta } from "/builds/marketing/website-2.0/pages/case-studies/investigator-college.vue?macro=true";
import { default as upgrade_45techaZc8gM0ZXhFAGpi3DUXLrr0X0uF0SvVMOGaGkRSIOf8Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/upgrade-tech.vue?macro=true";
import { default as indexigNgJMA7VYaykObTkqtq0LhH5dX6lchNSdRCX7qa7SgMeta } from "/builds/marketing/website-2.0/pages/enterprise/operator-connect/index.vue?macro=true";
import { default as fitted_45for_45work1K22Wz02UPiqkRZJusAd30EFUBn5_45UZYHuS6iZvOiwUMeta } from "/builds/marketing/website-2.0/pages/about-us/community/fitted-for-work.vue?macro=true";
import { default as constructionj6fdA8OM3vWWlSvHqspGdisBb7yM07Zb9Gk21dKRzFgMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/construction.vue?macro=true";
import { default as nbn_45fttp_45upgradejVGGtjOusNDHN11syWFCCc1X8JoudFawhevmPVC1DZEMeta } from "/builds/marketing/website-2.0/pages/business/internet/nbn-fttp-upgrade.vue?macro=true";
import { default as educationC_459INOJy9hjyW8Svra4ZsjoFL9djrQS0t6o78UG5qEAMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/education.vue?macro=true";
import { default as data_45securityxU7Ol3wAO_5mzixngV_pAKU6Wl8qd8pUMQ9Z8uBGZJMMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/data-security.vue?macro=true";
import { default as it_45complexitydisnEkP1Z3mqc4bzz7b0mzUA3lCMtrirpcWLcs74GksMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/it-complexity.vue?macro=true";
import { default as disaster_45supportK76UA95BrHJys9_456MrSVLjqILfc_qAInonuRkLu3gZEMeta } from "/builds/marketing/website-2.0/pages/about-us/community/disaster-support.vue?macro=true";
import { default as landmark_45international9ZqGqk6_v_45Wz5t2e4jMUcR_YuP4yHWqry8ZKoYzL3U4Meta } from "/builds/marketing/website-2.0/pages/case-studies/landmark-international.vue?macro=true";
import { default as healthcarehUfIuSd8x1BQarG9aVqJQ_45TsB7_45Mu6_45UVge9_45LZ5fjEMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/healthcare.vue?macro=true";
import { default as indexZz5j_2cMmt6Qgrp7gFfLylOUGaB22RHVo6f57iy8SKEMeta } from "/builds/marketing/website-2.0/pages/insights/telecom-in-australia/index.vue?macro=true";
import { default as latrobe_45regional_45healthsE24EpLlKa_jkKkqwYxibBm_45OqD63peaxB_YbrJRAO0Meta } from "/builds/marketing/website-2.0/pages/case-studies/latrobe-regional-health.vue?macro=true";
import { default as staff_45retentionQ9UrnjlcuQj_aNmsmfncRhsapfSf3MSJsLA3LcTT_F8Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/staff-retention.vue?macro=true";
import { default as mobile_45voiceqZVu5OEHd4utw98trwUAfm20OISzukvNBi7YCucnuQwMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/mobile-voice.vue?macro=true";
import { default as _91slug_93ajVpnvaA8k6oSIdljcM10rBBTeYLPJi2MwuRoRzSO0cMeta } from "/builds/marketing/website-2.0/pages/insights/telecom-in-australia/[slug].vue?macro=true";
import { default as network_45solutionskcMYuM7gVjf1HwwDct7b_d9vyIOx60x_qCvgV9IN_E0Meta } from "/builds/marketing/website-2.0/pages/wholesale/services/network-solutions.vue?macro=true";
import { default as enterprise_45ethernetxLtwwalUG45rS_45VSIITUY_qwq8E8CwfvJaixqktSR_0Meta } from "/builds/marketing/website-2.0/pages/business/internet/enterprise-ethernet.vue?macro=true";
import { default as bairnsdale_45internationalgeoqOs410GVyDKbH28NU9kguh6q16oNgO60ZynWztI4Meta } from "/builds/marketing/website-2.0/pages/case-studies/bairnsdale-international.vue?macro=true";
import { default as construction_45oHbQQUhMe6TCqs5Q4a08owWAQK6G_p2sR0fFPZPSyAMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/construction.vue?macro=true";
import { default as company_45securityO43YzDARUNqHjpCklz2OAlLB8sfLkcgLIBr920nw7oQMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/company-security.vue?macro=true";
import { default as indexAZAdCaxMMEvoZkc4HZPfucwsfdtMcCRPgzChjmBkZa0Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/index.vue?macro=true";
import { default as saseh6VzwOfHclqCDQYDBIXTbY_IfzsQhQOll4CASPEO9xYMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/security/sase.vue?macro=true";
import { default as index9SJtXprib37bhB_AyFRa_452FnNjlHVa1YkZnDDBeZQwkMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/index.vue?macro=true";
import { default as sd_45wanFFkPPReB5sXlpRJc_45E_cPBTsHyKa8pAcCKi7K0zrsx4Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/sd-wan.vue?macro=true";
import { default as indexS_45T9_wpnmUvPyZFP9kJrDOXyMTxcqrqjSMtYs1nBE9EMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/security/index.vue?macro=true";
import { default as index8P47qPLEDUqmcZvFMQ0dmIJD6grPy3TO2_jq6TWBohoMeta } from "/builds/marketing/website-2.0/pages/help-centre/accounts-and-billing/index.vue?macro=true";
import { default as network_45performanceRJkR7312B5fFHkPJq9hf9bhxOeYBkU7wBmH6YxiB8l8Meta } from "/builds/marketing/website-2.0/pages/enterprise/(by-need)/network-performance.vue?macro=true";
import { default as local_45governmentPz22TC4xvVFVF5ufdUSs83TIrFU_09fEd1j7fyMM5jMMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/local-government.vue?macro=true";
import { default as starlinkc7W1B4qiHNUYfP4uK63_J9TR8bgo4xWaVVBixNnR7tcMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/starlink.vue?macro=true";
import { default as Small_45Change_45Big_45ChangefIBxkkOmFAdifTvqFPq9ZZWIFypsgL5j1pFkrXf1LucMeta } from "/builds/marketing/website-2.0/pages/about-us/community/Small-Change-Big-Change.vue?macro=true";
import { default as nbn_45plans0Bj8Q4lqxkxEZMSqzhC9qQUfqUqLBGScR6bJjkyb18cMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/nbn-plans.vue?macro=true";
import { default as private_45ippzH2_MO1J2C0hEfJUAOqK2eIBk4A8mw1csSdUY18KrcMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/private-ip.vue?macro=true";
import { default as _91_46_46_46slug_9373wIgzPsboq7kx8MCk2ARXlKXVOv657JtwKpDaqoEnoMeta } from "/builds/marketing/website-2.0/pages/help-centre/accounts-and-billing/[...slug].vue?macro=true";
import { default as professional_45servicesS58TvWpl31d9U7HDPlk6tl8kqHwvhcL1xw28B7Jl0eYMeta } from "/builds/marketing/website-2.0/pages/business/(industries)/professional-services.vue?macro=true";
import { default as Helping_45Communities_45ConnectRgGzHLtPkZVv5yoGzaKoQE9uO2BXQv6yzXfkaPTxctgMeta } from "/builds/marketing/website-2.0/pages/about-us/community/Helping-Communities-Connect.vue?macro=true";
import { default as professional_45services_45kfrME2_NXb_7Iaj2hsCFff5h0B65Cc8qT3GNciWTEoMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-industry)/professional-services.vue?macro=true";
import { default as hosted_45firewallR_jz3cCMIFUGXbN_aSTOE0EJ7b2sxe_45eA8f_45IwpFkrIMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/hosted-firewall.vue?macro=true";
import { default as voip_45international_45call_45ratesznY910P8fek5rI6ulrOJxFhDgHrHqj_35ZYLYT41EgMMeta } from "/builds/marketing/website-2.0/pages/help-centre/phone/voip-international-call-rates.vue?macro=true";
import { default as data_45centre_45connect6rPc911avc1oAvugwW3uu49bvLcneQk4TBAu9SHiyDsMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/data-centre-connect.vue?macro=true";
import { default as enterprise_45ethernetdyAWTkqS2nNCuHUVc_45BffmdalbiwjQgl9pmkRHuo_3YMeta } from "/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/enterprise-ethernet.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/marketing/website-2.0/pages/index.vue")
  },
  {
    name: "lp-eofy",
    path: "/lp/eofy",
    component: () => import("/builds/marketing/website-2.0/pages/lp/eofy.vue")
  },
  {
    name: "lp",
    path: "/lp",
    component: () => import("/builds/marketing/website-2.0/pages/lp/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/builds/marketing/website-2.0/pages/blog/index.vue")
  },
  {
    name: "ssbi",
    path: "/ssbi",
    component: () => import("/builds/marketing/website-2.0/pages/ssbi/index.vue")
  },
  {
    name: "tools-appt",
    path: "/tools/appt",
    component: () => import("/builds/marketing/website-2.0/pages/tools/appt.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/builds/marketing/website-2.0/pages/legal/index.vue")
  },
  {
    name: "network-map",
    path: "/network/map",
    component: () => import("/builds/marketing/website-2.0/pages/network/map.vue")
  },
  {
    name: "speed",
    path: "/speed",
    meta: indexhsz4bqNeUWRKUoMLYkOybC7goDw8_FkTeYIQCxHfGV8Meta || {},
    component: () => import("/builds/marketing/website-2.0/pages/speed/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/marketing/website-2.0/pages/search/index.vue")
  },
  {
    name: "bundles",
    path: "/bundles",
    component: () => import("/builds/marketing/website-2.0/pages/bundles/index.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/builds/marketing/website-2.0/pages/careers/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/builds/marketing/website-2.0/pages/contact/index.vue")
  },
  {
    name: "mobile-slug",
    path: "/mobile/:slug()",
    component: () => import("/builds/marketing/website-2.0/pages/mobile/[slug].vue")
  },
  {
    name: "network",
    path: "/network",
    component: () => import("/builds/marketing/website-2.0/pages/network/index.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/builds/marketing/website-2.0/pages/reviews/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/blog/[...slug].vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/builds/marketing/website-2.0/pages/business/index.vue")
  },
  {
    name: "customer",
    path: "/customer",
    component: () => import("/builds/marketing/website-2.0/pages/customer/index.vue")
  },
  {
    name: "feedback-fault",
    path: "/feedback/fault",
    component: () => import("/builds/marketing/website-2.0/pages/feedback/fault.vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    component: () => import("/builds/marketing/website-2.0/pages/feedback/index.vue")
  },
  {
    name: "feedback-sales",
    path: "/feedback/sales",
    component: () => import("/builds/marketing/website-2.0/pages/feedback/sales.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/builds/marketing/website-2.0/pages/insights/index.vue")
  },
  {
    name: "blog-tags",
    path: "/blog/tags",
    component: () => import("/builds/marketing/website-2.0/pages/blog/tags/index.vue")
  },
  {
    name: "lp-black-friday",
    path: "/lp/black-friday",
    component: () => import("/builds/marketing/website-2.0/pages/lp/black-friday.vue")
  },
  {
    name: "network-outages",
    path: "/network/outages",
    component: () => import("/builds/marketing/website-2.0/pages/network/outages.vue")
  },
  {
    name: "wholesale",
    path: "/wholesale",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/index.vue")
  },
  {
    name: "business-contact",
    path: "/business/contact",
    component: () => import("/builds/marketing/website-2.0/pages/business/contact.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/index.vue")
  },
  {
    name: "internet-telstra",
    path: "/internet/telstra",
    component: () => import("/builds/marketing/website-2.0/pages/internet/telstra.vue")
  },
  {
    name: "speed-test",
    path: "/speed-test",
    component: () => import("/builds/marketing/website-2.0/pages/speed-test/index.vue")
  },
  {
    name: "wholesale-carbon",
    path: "/wholesale/carbon",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/carbon.vue")
  },
  {
    name: "blog-all-articles",
    path: "/blog/all-articles",
    component: () => import("/builds/marketing/website-2.0/pages/blog/all-articles.vue")
  },
  {
    name: "business-lp",
    path: "/business/lp",
    component: () => import("/builds/marketing/website-2.0/pages/business/lp/index.vue")
  },
  {
    name: "case-studies-nova",
    path: "/case-studies/nova",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/nova.vue")
  },
  {
    name: "contact-complaint",
    path: "/contact/complaint",
    component: () => import("/builds/marketing/website-2.0/pages/contact/complaint.vue")
  },
  {
    name: "help-centre",
    path: "/help-centre",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/index.vue")
  },
  {
    name: "internet-hardware",
    path: "/internet/hardware",
    component: () => import("/builds/marketing/website-2.0/pages/internet/hardware.vue")
  },
  {
    name: "moving-home",
    path: "/moving-home",
    component: () => import("/builds/marketing/website-2.0/pages/moving-home/index.vue")
  },
  {
    name: "blog-authors",
    path: "/blog/authors",
    component: () => import("/builds/marketing/website-2.0/pages/blog/authors/index.vue")
  },
  {
    name: "business-lp-akubra",
    path: "/business/lp/akubra",
    component: () => import("/builds/marketing/website-2.0/pages/business/lp/akubra.vue")
  },
  {
    name: "case-studies",
    path: "/case-studies",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/index.vue")
  },
  {
    name: "internet-nbn-plans",
    path: "/internet/nbn-plans",
    component: () => import("/builds/marketing/website-2.0/pages/internet/nbn-plans.vue")
  },
  {
    name: "media-centre",
    path: "/media-centre",
    component: () => import("/builds/marketing/website-2.0/pages/media-centre/index.vue")
  },
  {
    name: "myaussie-app",
    path: "/myaussie-app",
    component: () => import("/builds/marketing/website-2.0/pages/myaussie-app/index.vue")
  },
  {
    name: "network-cvc-graphs",
    path: "/network/cvc-graphs",
    component: () => import("/builds/marketing/website-2.0/pages/network/cvc-graphs.vue")
  },
  {
    name: "network-ping-times",
    path: "/network/ping-times",
    component: () => import("/builds/marketing/website-2.0/pages/network/ping-times.vue")
  },
  {
    name: "our-products",
    path: "/our-products",
    component: () => import("/builds/marketing/website-2.0/pages/our-products/index.vue")
  },
  {
    name: "tools-activate-sim",
    path: "/tools/activate-sim",
    component: () => import("/builds/marketing/website-2.0/pages/tools/activate-sim.vue")
  },
  {
    name: "tools-release-form",
    path: "/tools/release-form",
    meta: release_45formTf26KGFB0srA6C3YFMmpIDQqt_45IlVxt2k8a4Ppm1MS4Meta || {},
    component: () => import("/builds/marketing/website-2.0/pages/tools/release-form.vue")
  },
  {
    name: "wholesale-lp",
    path: "/wholesale/lp",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/lp/index.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/builds/marketing/website-2.0/pages/accessibility/index.vue")
  },
  {
    name: "blog-tags-slug",
    path: "/blog/tags/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/blog/tags/[...slug].vue")
  },
  {
    name: "case-studies-akubra",
    path: "/case-studies/akubra",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/akubra.vue")
  },
  {
    name: "enterprise-lp",
    path: "/enterprise/lp",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/lp/index.vue")
  },
  {
    name: "insights-tags",
    path: "/insights/tags",
    component: () => import("/builds/marketing/website-2.0/pages/insights/tags/index.vue")
  },
  {
    name: "internet-gamers-nbn",
    path: "/internet/gamers-nbn",
    component: () => import("/builds/marketing/website-2.0/pages/internet/gamers-nbn.vue")
  },
  {
    name: "internet-home-phone",
    path: "/internet/home-phone",
    component: () => import("/builds/marketing/website-2.0/pages/internet/home-phone.vue")
  },
  {
    name: "wholesale-msp",
    path: "/wholesale/msp",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/msp/index.vue")
  },
  {
    name: "case-studies-cumulus",
    path: "/case-studies/cumulus",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/cumulus.vue")
  },
  {
    name: "case-studies-westpac",
    path: "/case-studies/westpac",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/westpac.vue")
  },
  {
    name: "enterprise-lp-vmware",
    path: "/enterprise/lp/vmware",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/lp/vmware.vue")
  },
  {
    name: "internet-seniors-nbn",
    path: "/internet/seniors-nbn",
    component: () => import("/builds/marketing/website-2.0/pages/internet/seniors-nbn.vue")
  },
  {
    name: "legal-privacy-policy",
    path: "/legal/privacy-policy",
    component: () => import("/builds/marketing/website-2.0/pages/legal/privacy-policy.vue")
  },
  {
    name: "mobile-data-only-sim",
    path: "/mobile/data-only-sim",
    component: () => import("/builds/marketing/website-2.0/pages/mobile/data-only-sim.vue")
  },
  {
    name: "onboarding-hub",
    path: "/onboarding-hub",
    meta: indexJdvZjCwrOpEwSMQJ4ovEDd_45hDcisuL41EqrogFr_45d_AMeta || {},
    component: () => import("/builds/marketing/website-2.0/pages/onboarding-hub/index.vue")
  },
  {
    name: "refer-a-friend",
    path: "/refer-a-friend",
    component: () => import("/builds/marketing/website-2.0/pages/refer-a-friend/index.vue")
  },
  {
    name: "about-us-awards",
    path: "/about-us/awards",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/awards/index.vue")
  },
  {
    name: "business-testimonials",
    path: "/business/testimonials",
    component: () => import("/builds/marketing/website-2.0/pages/business/testimonials.vue")
  },
  {
    name: "business-voice-zintel",
    path: "/business/voice/zintel",
    component: () => import("/builds/marketing/website-2.0/pages/business/voice/zintel.vue")
  },
  {
    name: "investor-centre",
    path: "/investor-centre",
    component: () => import("/builds/marketing/website-2.0/pages/investor-centre/index.vue")
  },
  {
    name: "mobile-sim-only-plans",
    path: "/mobile/sim-only-plans",
    component: () => import("/builds/marketing/website-2.0/pages/mobile/sim-only-plans.vue")
  },
  {
    name: "wholesale-white-label",
    path: "/wholesale/white-label",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/white-label.vue")
  },
  {
    name: "blog-authors-slug",
    path: "/blog/authors/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/blog/authors/[...slug].vue")
  },
  {
    name: "case-studies-ace-radio",
    path: "/case-studies/ace-radio",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/ace-radio.vue")
  },
  {
    name: "case-studies-foodworks",
    path: "/case-studies/foodworks",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/foodworks.vue")
  },
  {
    name: "case-studies-green-cup",
    path: "/case-studies/green-cup",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/green-cup.vue")
  },
  {
    name: "help-centre-tags",
    path: "/help-centre/tags",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/tags/index.vue")
  },
  {
    name: "insights-leaders",
    path: "/insights/leaders",
    component: () => import("/builds/marketing/website-2.0/pages/insights/leaders/index.vue")
  },
  {
    name: "internet-entertainment",
    path: "/internet/entertainment",
    component: () => import("/builds/marketing/website-2.0/pages/internet/entertainment.vue")
  },
  {
    name: "internet-ultrafast-nbn",
    path: "/internet/ultrafast-nbn",
    component: () => import("/builds/marketing/website-2.0/pages/internet/ultrafast-nbn.vue")
  },
  {
    name: "media-centre-slug",
    path: "/media-centre/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/media-centre/[...slug].vue")
  },
  {
    name: "tools-fibre-operations",
    path: "/tools/fibre-operations",
    meta: fibre_45operationsr_e9n_IZY3Q7FuExOxk_eDAUlBvSWl_45tYE9nE_45scmfsMeta || {},
    component: () => import("/builds/marketing/website-2.0/pages/tools/fibre-operations.vue")
  },
  {
    name: "business-feedback",
    path: "/business/feedback",
    component: () => import("/builds/marketing/website-2.0/pages/business/feedback/index.vue")
  },
  {
    name: "enterprise-carbon",
    path: "/enterprise/carbon",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/carbon/index.vue")
  },
  {
    name: "help-centre-phone",
    path: "/help-centre/phone",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/phone/index.vue")
  },
  {
    name: "insights-leaders-slug",
    path: "/insights/leaders/:slug()",
    component: () => import("/builds/marketing/website-2.0/pages/insights/leaders/[slug].vue")
  },
  {
    name: "insights-tags-slug",
    path: "/insights/tags/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/insights/tags/[...slug].vue")
  },
  {
    name: "internet-fixed-wireless",
    path: "/internet/fixed-wireless",
    component: () => import("/builds/marketing/website-2.0/pages/internet/fixed-wireless.vue")
  },
  {
    name: "internet-opticomm-plans",
    path: "/internet/opticomm-plans",
    component: () => import("/builds/marketing/website-2.0/pages/internet/opticomm-plans.vue")
  },
  {
    name: "lp-big-tech-competition",
    path: "/lp/big-tech-competition",
    component: () => import("/builds/marketing/website-2.0/pages/lp/big-tech-competition.vue")
  },
  {
    name: "wholesale-carrier",
    path: "/wholesale/carrier",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/carrier/index.vue")
  },
  {
    name: "wholesale-services-data",
    path: "/wholesale/services/data",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/services/data.vue")
  },
  {
    name: "about-us-community",
    path: "/about-us/community",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/index.vue")
  },
  {
    name: "business-voice-faktortel",
    path: "/business/voice/faktortel",
    component: () => import("/builds/marketing/website-2.0/pages/business/voice/faktortel.vue")
  },
  {
    name: "case-studies-harris-wood",
    path: "/case-studies/harris-wood",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/harris-wood.vue")
  },
  {
    name: "enterprise-contact",
    path: "/enterprise/contact",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/contact/index.vue")
  },
  {
    name: "help-centre-mobile",
    path: "/help-centre/mobile",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/mobile/index.vue")
  },
  {
    name: "mobile-3g-network-change",
    path: "/mobile/3g-network-change",
    component: () => import("/builds/marketing/website-2.0/pages/mobile/3g-network-change.vue")
  },
  {
    name: "wholesale-services-voice",
    path: "/wholesale/services/voice",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/services/voice.vue")
  },
  {
    name: "about-us-leadership",
    path: "/about-us/leadership",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/leadership/index.vue")
  },
  {
    name: "business-mobile-4g-backup",
    path: "/business/mobile/4g-backup",
    component: () => import("/builds/marketing/website-2.0/pages/business/mobile/4g-backup.vue")
  },
  {
    name: "business-mobile-sim-plans",
    path: "/business/mobile/sim-plans",
    component: () => import("/builds/marketing/website-2.0/pages/business/mobile/sim-plans.vue")
  },
  {
    name: "business-voice-hosted-pbx",
    path: "/business/voice/hosted-pbx",
    component: () => import("/builds/marketing/website-2.0/pages/business/voice/hosted-pbx.vue")
  },
  {
    name: "business-voice-sip-trunks",
    path: "/business/voice/sip-trunks",
    component: () => import("/builds/marketing/website-2.0/pages/business/voice/sip-trunks.vue")
  },
  {
    name: "business-voice-voip-phone",
    path: "/business/voice/voip-phone",
    component: () => import("/builds/marketing/website-2.0/pages/business/voice/voip-phone.vue")
  },
  {
    name: "high-speed-upgrades",
    path: "/high-speed-upgrades",
    component: () => import("/builds/marketing/website-2.0/pages/high-speed-upgrades/index.vue")
  },
  {
    name: "internet-nbn-fttp-upgrade",
    path: "/internet/nbn-fttp-upgrade",
    component: () => import("/builds/marketing/website-2.0/pages/internet/nbn-fttp-upgrade.vue")
  },
  {
    name: "media-centre-all-articles",
    path: "/media-centre/all-articles",
    component: () => import("/builds/marketing/website-2.0/pages/media-centre/all-articles.vue")
  },
  {
    name: "wholesale-partner-program",
    path: "/wholesale/partner-program",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/partner-program.vue")
  },
  {
    name: "about-us-our-history",
    path: "/about-us/our-history",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/our-history/index.vue")
  },
  {
    name: "business-internet-fortinet",
    path: "/business/internet/fortinet",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/fortinet.vue")
  },
  {
    name: "case-studies-akd-softwoods",
    path: "/case-studies/akd-softwoods",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/akd-softwoods.vue")
  },
  {
    name: "help-centre-internet",
    path: "/help-centre/internet",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/internet/index.vue")
  },
  {
    name: "help-centre-tags-slug",
    path: "/help-centre/tags/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/tags/[...slug].vue")
  },
  {
    name: "wholesale-become-a-partner",
    path: "/wholesale/become-a-partner",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/become-a-partner.vue")
  },
  {
    name: "business-internet-nbn-plans",
    path: "/business/internet/nbn-plans",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/nbn-plans.vue")
  },
  {
    name: "case-studies-great-southern",
    path: "/case-studies/great-southern",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/great-southern.vue")
  },
  {
    name: "case-studies-james-cook-uni",
    path: "/case-studies/james-cook-uni",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/james-cook-uni.vue")
  },
  {
    name: "enterprise-it",
    path: "/enterprise/it",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/it.vue")
  },
  {
    name: "enterprise-lp-webex-connect",
    path: "/enterprise/lp/webex-connect",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/lp/webex-connect.vue")
  },
  {
    name: "help-centre-phone-slug",
    path: "/help-centre/phone/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/phone/[...slug].vue")
  },
  {
    name: "insights-product-news",
    path: "/insights/product-news",
    component: () => import("/builds/marketing/website-2.0/pages/insights/product-news/index.vue")
  },
  {
    name: "network-connection-insights",
    path: "/network/connection-insights",
    component: () => import("/builds/marketing/website-2.0/pages/network/connection-insights.vue")
  },
  {
    name: "network-mobile-coverage-map",
    path: "/network/mobile-coverage-map",
    component: () => import("/builds/marketing/website-2.0/pages/network/mobile-coverage-map.vue")
  },
  {
    name: "business-retail",
    path: "/business/retail",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/retail.vue")
  },
  {
    name: "case-studies-mundaring-shire",
    path: "/case-studies/mundaring-shire",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/mundaring-shire.vue")
  },
  {
    name: "help-centre-mobile-slug",
    path: "/help-centre/mobile/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/mobile/[...slug].vue")
  },
  {
    name: "insights-product-news-slug",
    path: "/insights/product-news/:slug()",
    component: () => import("/builds/marketing/website-2.0/pages/insights/product-news/[slug].vue")
  },
  {
    name: "business-finance",
    path: "/business/finance",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/finance.vue")
  },
  {
    name: "case-studies-national-storage",
    path: "/case-studies/national-storage",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/national-storage.vue")
  },
  {
    name: "case-studies-vicses-nillumbik",
    path: "/case-studies/vicses-nillumbik",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/vicses-nillumbik.vue")
  },
  {
    name: "enterprise-cloud",
    path: "/enterprise/cloud",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/cloud.vue")
  },
  {
    name: "business-business-success-team",
    path: "/business/business-success-team",
    component: () => import("/builds/marketing/website-2.0/pages/business/business-success-team.vue")
  },
  {
    name: "business-internet-aussie-fibre",
    path: "/business/internet/aussie-fibre",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/aussie-fibre.vue")
  },
  {
    name: "business-lp-aussie-fibre-ebook",
    path: "/business/lp/aussie-fibre-ebook",
    component: () => import("/builds/marketing/website-2.0/pages/business/lp/aussie-fibre-ebook.vue")
  },
  {
    name: "help-centre-internet-slug",
    path: "/help-centre/internet/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/internet/[...slug].vue")
  },
  {
    name: "lp-legendary-ashes-competition",
    path: "/lp/legendary-ashes-competition",
    component: () => import("/builds/marketing/website-2.0/pages/lp/legendary-ashes-competition.vue")
  },
  {
    name: "business-education",
    path: "/business/education",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/education.vue")
  },
  {
    name: "case-studies-townsville-diocese",
    path: "/case-studies/townsville-diocese",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/townsville-diocese.vue")
  },
  {
    name: "enterprise-retail",
    path: "/enterprise/retail",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/retail.vue")
  },
  {
    name: "wholesale-services-aussie-fibre",
    path: "/wholesale/services/aussie-fibre",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/services/aussie-fibre.vue")
  },
  {
    name: "business-healthcare",
    path: "/business/healthcare",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/healthcare.vue")
  },
  {
    name: "business-mobile-mobile-broadband",
    path: "/business/mobile/mobile-broadband",
    component: () => import("/builds/marketing/website-2.0/pages/business/mobile/mobile-broadband.vue")
  },
  {
    name: "enterprise-finance",
    path: "/enterprise/finance",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/finance.vue")
  },
  {
    name: "wholesale-services-voice-carrier",
    path: "/wholesale/services/voice-carrier",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/services/voice-carrier.vue")
  },
  {
    name: "about-us-community-Sustainability",
    path: "/about-us/community/Sustainability",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/Sustainability.vue")
  },
  {
    name: "business-internet-network-devices",
    path: "/business/internet/network-devices",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/network-devices.vue")
  },
  {
    name: "case-studies-cfa-hoppers-crossing",
    path: "/case-studies/cfa-hoppers-crossing",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/cfa-hoppers-crossing.vue")
  },
  {
    name: "case-studies-investigator-college",
    path: "/case-studies/investigator-college",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/investigator-college.vue")
  },
  {
    name: "enterprise-upgrade-tech",
    path: "/enterprise/upgrade-tech",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/upgrade-tech.vue")
  },
  {
    name: "enterprise-operator-connect",
    path: "/enterprise/operator-connect",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/operator-connect/index.vue")
  },
  {
    name: "about-us-community-fitted-for-work",
    path: "/about-us/community/fitted-for-work",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/fitted-for-work.vue")
  },
  {
    name: "business-construction",
    path: "/business/construction",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/construction.vue")
  },
  {
    name: "business-internet-nbn-fttp-upgrade",
    path: "/business/internet/nbn-fttp-upgrade",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/nbn-fttp-upgrade.vue")
  },
  {
    name: "enterprise-education",
    path: "/enterprise/education",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/education.vue")
  },
  {
    name: "enterprise-data-security",
    path: "/enterprise/data-security",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/data-security.vue")
  },
  {
    name: "enterprise-it-complexity",
    path: "/enterprise/it-complexity",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/it-complexity.vue")
  },
  {
    name: "about-us-community-disaster-support",
    path: "/about-us/community/disaster-support",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/disaster-support.vue")
  },
  {
    name: "case-studies-landmark-international",
    path: "/case-studies/landmark-international",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/landmark-international.vue")
  },
  {
    name: "enterprise-healthcare",
    path: "/enterprise/healthcare",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/healthcare.vue")
  },
  {
    name: "insights-telecom-in-australia",
    path: "/insights/telecom-in-australia",
    component: () => import("/builds/marketing/website-2.0/pages/insights/telecom-in-australia/index.vue")
  },
  {
    name: "case-studies-latrobe-regional-health",
    path: "/case-studies/latrobe-regional-health",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/latrobe-regional-health.vue")
  },
  {
    name: "enterprise-staff-retention",
    path: "/enterprise/staff-retention",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/staff-retention.vue")
  },
  {
    name: "enterprise-mobile-voice",
    path: "/enterprise/mobile-voice",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/mobile-voice.vue")
  },
  {
    name: "insights-telecom-in-australia-slug",
    path: "/insights/telecom-in-australia/:slug()",
    component: () => import("/builds/marketing/website-2.0/pages/insights/telecom-in-australia/[slug].vue")
  },
  {
    name: "wholesale-services-network-solutions",
    path: "/wholesale/services/network-solutions",
    component: () => import("/builds/marketing/website-2.0/pages/wholesale/services/network-solutions.vue")
  },
  {
    name: "business-internet-enterprise-ethernet",
    path: "/business/internet/enterprise-ethernet",
    component: () => import("/builds/marketing/website-2.0/pages/business/internet/enterprise-ethernet.vue")
  },
  {
    name: "case-studies-bairnsdale-international",
    path: "/case-studies/bairnsdale-international",
    component: () => import("/builds/marketing/website-2.0/pages/case-studies/bairnsdale-international.vue")
  },
  {
    name: "enterprise-construction",
    path: "/enterprise/construction",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/construction.vue")
  },
  {
    name: "enterprise-company-security",
    path: "/enterprise/company-security",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/company-security.vue")
  },
  {
    name: "enterprise-network",
    path: "/enterprise/network",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/index.vue")
  },
  {
    name: "enterprise-security-sase",
    path: "/enterprise/security/sase",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/security/sase.vue")
  },
  {
    name: "enterprise-internet",
    path: "/enterprise/internet",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/index.vue")
  },
  {
    name: "enterprise-network-sd-wan",
    path: "/enterprise/network/sd-wan",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/sd-wan.vue")
  },
  {
    name: "enterprise-security",
    path: "/enterprise/security",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/security/index.vue")
  },
  {
    name: "help-centre-accounts-and-billing",
    path: "/help-centre/accounts-and-billing",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/accounts-and-billing/index.vue")
  },
  {
    name: "enterprise-network-performance",
    path: "/enterprise/network-performance",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-need)/network-performance.vue")
  },
  {
    name: "enterprise-local-government",
    path: "/enterprise/local-government",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/local-government.vue")
  },
  {
    name: "enterprise-internet-starlink",
    path: "/enterprise/internet/starlink",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/starlink.vue")
  },
  {
    name: "about-us-community-Small-Change-Big-Change",
    path: "/about-us/community/Small-Change-Big-Change",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/Small-Change-Big-Change.vue")
  },
  {
    name: "enterprise-internet-nbn-plans",
    path: "/enterprise/internet/nbn-plans",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/nbn-plans.vue")
  },
  {
    name: "enterprise-network-private-ip",
    path: "/enterprise/network/private-ip",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/private-ip.vue")
  },
  {
    name: "help-centre-accounts-and-billing-slug",
    path: "/help-centre/accounts-and-billing/:slug(.*)*",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/accounts-and-billing/[...slug].vue")
  },
  {
    name: "business-professional-services",
    path: "/business/professional-services",
    component: () => import("/builds/marketing/website-2.0/pages/business/(industries)/professional-services.vue")
  },
  {
    name: "about-us-community-Helping-Communities-Connect",
    path: "/about-us/community/Helping-Communities-Connect",
    component: () => import("/builds/marketing/website-2.0/pages/about-us/community/Helping-Communities-Connect.vue")
  },
  {
    name: "enterprise-professional-services",
    path: "/enterprise/professional-services",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-industry)/professional-services.vue")
  },
  {
    name: "enterprise-network-hosted-firewall",
    path: "/enterprise/network/hosted-firewall",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/hosted-firewall.vue")
  },
  {
    name: "help-centre-phone-voip-international-call-rates",
    path: "/help-centre/phone/voip-international-call-rates",
    component: () => import("/builds/marketing/website-2.0/pages/help-centre/phone/voip-international-call-rates.vue")
  },
  {
    name: "enterprise-network-data-centre-connect",
    path: "/enterprise/network/data-centre-connect",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/network/data-centre-connect.vue")
  },
  {
    name: "enterprise-internet-enterprise-ethernet",
    path: "/enterprise/internet/enterprise-ethernet",
    component: () => import("/builds/marketing/website-2.0/pages/enterprise/(by-product)/internet/enterprise-ethernet.vue")
  }
]